import { inject, Injectable, RendererFactory2 } from '@angular/core';
import { environment } from '@environments/environment';

declare global {
  function fbq(event: 'track', eventName: string, params: Record<string, string>): void;
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private rendererFactory = inject(RendererFactory2);
  renderer = this.rendererFactory.createRenderer(null, null);
  pixelId = environment.facebookPixelCode;
  header = document.getElementsByTagName('head')[0];
  private scriptElement: HTMLScriptElement | undefined;

  addPixelScript() {
    const pixelCode =
      "\n  var pixelCode = function(f,b,e,v,n,t,s)\n    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n    n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n    n.queue=[];t=b.createElement(e);t.async=!0;\n    t.src=v;s=b.getElementsByTagName(e)[0];\n    s.parentNode.insertBefore(t,s)}(window, document,'script',\n    'https://connect.facebook.net/en_US/fbevents.js');\n fbq('init', " +
      this.pixelId +
      ") \n fbq('track', 'PageView');\n    ";
    this.scriptElement = this.renderer.createElement('script');
    this.renderer.setAttribute(this.scriptElement, 'id', 'pixel-script');
    this.renderer.setAttribute(this.scriptElement, 'type', 'text/javascript');
    this.renderer.setProperty(this.scriptElement, 'innerHTML', pixelCode);
    this.renderer.appendChild(this.header, this.scriptElement);
  }

  removePixelScript() {
    this.renderer.removeChild(this.header, this.scriptElement);
  }
}
